import { Component, OnInit } from '@angular/core';
import * as Constants from '@emi/shared/constants';

@Component({
    selector: 'via-ui-export-route',
    templateUrl: './export-route.component.html',
    styleUrls: ['./export-route.component.scss'],
})
export class ExportRouteComponent implements OnInit {
    constructor() {}

    public ngOnInit(): void {
        window.location.href = `/${Constants.Routes.EXTRACT_APP_URL}`;
    }
}
